import { render, staticRenderFns } from "./zhiling-open.vue?vue&type=template&id=68329f83&scoped=true"
import script from "./zhiling-open.vue?vue&type=script&lang=js"
export * from "./zhiling-open.vue?vue&type=script&lang=js"
import style0 from "./zhiling-open.vue?vue&type=style&index=0&id=68329f83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68329f83",
  null
  
)

/* custom blocks */
import block0 from "./zhiling-open.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports